module.exports = __webpack_public_path__ + "img/docs.6ef784bd.svg";